export default "__VITE_ASSET__CiJr7$1i__"